<template>
  <table class="table center">
    <!-- 供应商基本信息 -->
    <sup-base-info v-model="showAddress" :details="details" readonly />

    <!-- 经营者信息 -->
    <sup-operators
      v-model="showAddress"
      @setOpertionNum="setOpertionNum"
      :details="details"
      readonly
    />

    <!-- 紧急联系人信息 -->
    <sup-contacts :details="details" readonly />

    <!-- 历史记录 -->
    <sup-historical
      :details="supplierHistoryList"
      :expandUserName="details.expandUserName"
      readonly
    />

    <!-- 设备信息 -->
    <devices-info
      v-model="showAddress"
      :details="deviceInfos"
      @setOpertionNum="setOpertionNum"
    />

    <!-- 业务所属 -->
    <!-- <ownership :details="details" /> -->

    <!-- 终端信息 -->
    <tr>
      <th colspan="10">终端信息</th>
    </tr>
    <tr v-for="(pos, index) of supplierPosList" :key="index">
      <td>受理终端号</td>
      <td colspan="3">
        <el-input v-model="pos.hardwareId" readonly />
      </td>
      <td>SIM序列号</td>
      <td colspan="5">
        <el-input v-model="pos.simId" readonly />
      </td>
    </tr>
    <tr v-if="supplierPosList && !supplierPosList.length">
      <td colspan="10" class="center">暂无终端</td>
    </tr>
    <tr>
      <th colspan="10">资质查询</th>
    </tr>

    <tr>
      <td colspan="10">
        <upload-file
          readonly
          name="营业执照"
          v-model="details.licensePhotoUrl"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="法人身份证(正面)"
          v-model="details.urlCardFront"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="法人身份证(背面)"
          v-model="details.urlCardBack"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="收银台"
          v-model="details.urlCashier"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="店铺照片"
          v-model="details.officePhotoUrl"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="门头照"
          v-model="details.doorPhotoUrl"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="脸部特征"
          v-model="details.urlFacialFeature"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="签字"
          v-model="details.urlSignature"
          :previewList="previewList"
        />
        <upload-file
          readonly
          name="法人授权书"
          v-model="details.urlCorpMandate"
          :previewList="previewList"
        />
      </td>
    </tr>
  </table>
</template>

<script>
import SupBaseInfo from '@/components/DetailsSupplier/BaseInfo'
import SupOperators from '@/components/DetailsSupplier/Operators'
import SupContacts from '@/components/DetailsSupplier/Contacts'
import SupHistorical from '@/components/DetailsSupplier/Historical'
import DevicesInfo from '@/components/DetailsSupplier/DevicesInfo'
import Ownership from '@/components/DetailsSupplier/Ownership'

export default {
  components: {
    SupBaseInfo,
    SupOperators,
    SupContacts,
    SupHistorical,
    DevicesInfo,
    Ownership
  },

  props: {
    id: {
      type: String,
      comment: '供应商档案号'
    },
    details: {
      type: Object,
      default() {
        return {}
      },
      comment: '供应商基本信息'
    }
  },

  data() {
    return {
      showAddress: false,
      deviceInfos: {},
      supplierPosList: [], // 支付终端信息
      supplierHistoryList: [] //历史记录信息
    }
  },

  computed: {
    previewList() {
      const {
        officePhotoUrl,
        urlCardFront,
        urlCardBack,
        urlCashier,
        doorPhotoUrl,
        licensePhotoUrl,
        urlSignature,
        urlFacialFeature,
        urlCorpMandate
      } = this.details

      return [
        licensePhotoUrl,
        urlCashier,
        urlCardFront,
        urlCardBack,
        officePhotoUrl,
        doorPhotoUrl,
        urlFacialFeature,
        urlSignature,
        urlCorpMandate
      ]
    }
  },

  async created() {
    this.getSupplierPos() // 获取终端信息
    this.getAppUserInfo() // 获取设备信息
    this.supplierHistory() // 历史记录
  },

  methods: {
    setOpertionNum(num) {
      this.details.entryLatitude = this.deviceInfos.entryLatitude
      this.details.entryLongitude = this.deviceInfos.entryLongitude
      this.details.opertionNum = num
    },
    getAppUserInfo() {
      const {
        id,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'public/getAppUserInfo'

      dispatch(dispatchEvent, {
        type: 'supplier',
        archivesNo: id
      }).then(res => {
        this.deviceInfos = res
      })
    },

    // 获取支付终端信息列表
    async getSupplierPos() {
      const { supId } = this.details
      const { dispatch } = this.$store
      const dispatchEvent = 'T2/supplierCheck/getSupplierPos'

      await dispatch(dispatchEvent, { supId }).then(res => {
        this.supplierPosList = res.data || []
      })
    },

    // 详情 => 历史记录
    async supplierHistory() {
      let { id } = this
      let { dispatch } = this.$store
      let dispatchEvent = 'T3/acceptReview/supplierHistory'

      let res = await dispatch(dispatchEvent, { supId: id })
      console.log(res, '历史记录')
      this.supplierHistoryList = res || []
    }
  }
}
</script>

<style lang="scss">
@import '@/css/Common/detailsTable.scss';
</style>
